import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { getGlobalMarketData } from '../../utils/mockDataGenerator';

const MarketOverview: React.FC = () => {
  const marketData = getGlobalMarketData();

  const formatNumber = (num: number) => {
    if (num >= 1e12) return `$${(num / 1e12).toFixed(2)}T`;
    if (num >= 1e9) return `$${(num / 1e9).toFixed(2)}B`;
    return `$${(num / 1e6).toFixed(2)}M`;
  };

  const formatPercentage = (num: number) => `${num.toFixed(1)}%`;

  const stats = [
    { label: 'Market Cap', value: formatNumber(marketData.total_market_cap), change: '+2.4%', positive: true },
    { label: '24h Volume', value: formatNumber(marketData.total_24h_volume), change: '-1.2%', positive: false },
    { label: 'BTC Dominance', value: formatPercentage(marketData.btc_dominance), change: '+0.3%', positive: true },
    { label: 'ETH Dominance', value: formatPercentage(marketData.eth_dominance), change: '-0.1%', positive: false },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-6">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="glass-effect rounded-xl p-3 sm:p-4"
        >
          <p className="text-xs text-zinc-500 mb-1">{stat.label}</p>
          <p className="text-base sm:text-xl font-semibold mb-1">{stat.value}</p>
          <div className="flex items-center space-x-1">
            {stat.positive ? (
              <TrendingUp className="w-3 h-3 text-green-500" />
            ) : (
              <TrendingDown className="w-3 h-3 text-red-500" />
            )}
            <span className={`text-xs ${stat.positive ? 'text-green-500' : 'text-red-500'}`}>
              {stat.change}
            </span>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default MarketOverview;